import { render, staticRenderFns } from "./BotonAgregar.vue?vue&type=template&id=826b8c6c"
import script from "./BotonAgregar.vue?vue&type=script&lang=js"
export * from "./BotonAgregar.vue?vue&type=script&lang=js"
import style0 from "./BotonAgregar.vue?vue&type=style&index=0&id=826b8c6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports